import React, { FC, useState } from "react";
import { Table } from "reactstrap";
import { v4 } from "uuid";
import { IPartnerOrderDetail } from "../../../../../interfaces/order";

// styles
import styles from "./ProductsTable.module.scss";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/system";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import { MoreVert } from "@material-ui/icons";

interface IProps {
  orderItems: IPartnerOrderDetail[] | undefined;
}

const ProductsTable: FC<IProps> = ({ orderItems }) => {
  return (
    <>
      <Table size="sm" responsive>
        <thead>
          <tr id={styles.table_head}>
            <th>Product</th>
            {/* <th id={styles.stockcount}>Available Stock Count</th> */}
            <th id={styles.quantity}>Quantity</th>
            <th id={styles.quantity}>Total</th>
          </tr>
        </thead>

        <tbody>
          {orderItems &&
            orderItems
              .filter((item: IPartnerOrderDetail) => item.IsPayment === false)
              .map((orderItem: IPartnerOrderDetail) => (
                <>
                  <tr id={styles.row} key={orderItem.PartnerOrderDetailsId}>
                    <td>
                      <Stack spacing={0.5} mb={-2}>
                        {orderItem.OrderItem.ItemName}
                        {orderItem.SpecialInstructions && (
                          <p>
                            <span id={styles.sirow}>
                              {orderItem.SpecialInstructions}
                            </span>
                          </p>
                        )}
                      </Stack>
                    </td>
                    {/* <td id={styles.stockcount}>
                    <Chip
                      label={orderItem.AvailableStockCount.toFixed(3)}
                      variant="outlined"
                      color={
                        orderItem.AvailableStockCount < orderItem.ItemQuantity
                          ? "error"
                          : "success"
                      }
                    />
                    
                  </td> */}
                    <td id={styles.quantity}>
                      {orderItem.ItemQuantity.toFixed(3)}
                    </td>
                    <td id={styles.quantity}>
                      {(
                        orderItem.TransactionPrice * orderItem.ItemQuantity
                      ).toFixed(2)}
                    </td>

                    {/*                 <td>
                  <MoreVert onClick={onClick} />
                </td> */}
                  </tr>
                  {/*               <tr id={styles.sirow}>
                <td>
                                     <span id={styles.spiWord}>
                    Special Instructions for {orderItem.OrderItem.ItemName} :
                  </span>{" "}
                  {orderItem.SpecialInstructions}
                </td>
              </tr> */}
                </>
              ))}
        </tbody>
      </Table>
    </>
  );
};

export default ProductsTable;
